import type { FC, SVGProps } from 'react'

import faviconFit from '@/assets/images/favicon.png'
import faviconImo from '@/assets/images/faviconImo.png'
import { ReactComponent as LogoFit } from '@/assets/svgs/logo.svg'
import { ReactComponent as LogoImo } from '@/assets/svgs/logoImo.svg'

type AppFlavor = 'fit' | 'imo'

interface Branding {
  flavor: AppFlavor
  favicon: string
  title: string
  legalLinks?: {
    terms: string
    privacy: string
  }
  headerLogo: {
    component: FC<SVGProps<SVGSVGElement>>
    width: string
    height?: string
  }
}

const brandingByFlavor: Record<AppFlavor, Branding> = {
  // TODO: Replace legacy documents with flavor-specific legal documents for non-iMO flavors.
  fit: {
    flavor: 'fit',
    favicon: faviconFit,
    title: 'Allimb',
    headerLogo: {
      component: LogoFit,
      width: '120px'
    }
  },
  imo: {
    flavor: 'imo',
    favicon: faviconImo,
    title: 'iMO Motion',
    legalLinks: {
      terms: 'https://imo.plaingood.tech/it/specialist-terms',
      privacy: 'https://imo.plaingood.tech/it/privacy'
    },
    headerLogo: {
      component: LogoImo,
      width: '48px',
      height: '48px'
    }
  }
}

const branding = import.meta.env.VITE_APP_FLAVOR === 'imo'
  ? brandingByFlavor.imo
  : brandingByFlavor.fit

export default branding
